import { useState } from "react";

import { useDomSize } from "~/hook/base/useDomSize.ts";
import { usePoke } from "~/hook/domain/usePoke.ts";
import { getNormalizedPoints } from "~/service/util.ts";
import { type Line } from "~/ui/base/Canvas.tsx";

export const PALETTE = [
  "#53B7F9",
  "#76FB4C",
  "#EA33F4",
  "#DA3832",
  "#EF8532",
  "#FEFC53",
  "#FFFFFF",
];

export const usePokeWithDrawing = (email: string, close: () => void) => {
  const {
    domRef,
    size: { height, width },
  } = useDomSize<HTMLDivElement>();

  const [selectedColor, setSelectedColor] = useState(PALETTE[0]);
  const [lines, setLines] = useState<Line[]>([]);

  const { isMutating, trigger } = usePoke();

  const handleClear = () => {
    setLines([]);
  };

  const handleSend = () => {
    void trigger({
      email,
      payload: {
        lines: getNormalizedPoints(width)(lines),
        type: "drawing",
      },
    }).then(close);
  };

  return {
    domRef,
    handleClear,
    handleSend,
    height,
    isMutating,
    lines,
    selectedColor,
    setLines,
    setSelectedColor,
    width,
  };
};
